import { BASE_URL } from 'consts/urls';
import { QueryClient } from '@tanstack/react-query';
import { getCookie, removeCookie, setCookie } from 'utils/TokenUtils';

//useQuery 계속 콜되는 막기, refetch 할때만 콜하기
export const getClient = (() => {
  let client: QueryClient | null = null;
  return () => {
    if (!client)
      client = new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 0,
            gcTime: Infinity,
            refetchOnMount: false,
            refetchOnReconnect: false,
            refetchOnWindowFocus: false,
            enabled: false
          }
        }
      });
    return client;
  };
})();

let isAlertDisplayed = false;

export const restfetcher = async ({
  method,
  path,
  params
}: {
  method: 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
  path: string;
  params?: { [key: string]: any | FormData };
}) => {
  try {
    const token = getCookie('dashboardToken');

    const url = path.includes('http') ? path : `${BASE_URL}${path}`;
    const fetchOptions: any = {
      method
    };

    const needTokenPaths = [
      'dashboard/center/info',
      'dashboard/month/measurement/count',
      'dashboard/employee/stats',
      'dashboard/posture/stats',
      'dashboard/rom/stats',
      'dashboard/posture/stats/detail',
      'dashboard/employee/stats/detail',
      'dashboard/rom/stats/detail'
    ];

    // 현재 `path`가 `specialPaths` 배열에 포함되어 있는지 확인
    const isNeedTokenPath = needTokenPaths.includes(path);

    if (params) {
      if (params instanceof FormData) {
        fetchOptions.body = params;
        fetchOptions.headers = {
          Authorization: `Bearer ${token}`
        };
      } else if (isNeedTokenPath) {
        fetchOptions.body = JSON.stringify(params);
        fetchOptions.headers = {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        };
      } else {
        fetchOptions.body = JSON.stringify(params);
        fetchOptions.headers = {
          'Content-Type': 'application/json'
          // Authorization: `Bearer ${token}`,
        };
      }
    } else {
      return false;
    }

    const res = await fetch(url, fetchOptions);
    const json = await res?.json();

    if (!res.ok || json?.errcode === 401) {
      if (res.status === 401 || (res.status === 200 && token)) {
        const refresh = localStorage?.getItem('refresh');
        const fetchOptionsToken: any = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          }
        };
        if (refresh && token) {
          fetchOptionsToken.body = JSON.stringify({ token: refresh });
          const refreshedToken = await fetch(
            `${BASE_URL}auth/token`,
            fetchOptionsToken
          );
          const refreshedTokenJson = await refreshedToken?.json();
          const authenticatetoken = refreshedTokenJson?.authenticatetoken;

          if (authenticatetoken) {
            const { jwt, refresh } = authenticatetoken;
            if (refreshedToken && jwt && refresh) {
              setCookie('dashboardToken', jwt, {
                secure: true,
                sameSite: 'strict'
              });
              localStorage?.setItem('refresh', refresh);

              fetchOptions.headers = {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${jwt}`
              };
              const refreshedResponse = await fetch(url, fetchOptions);
              const refreshedResult = await refreshedResponse.json();
              // setData(refreshedResult);
              return refreshedResult;
            } else {
              if (refreshedTokenJson.status === 403 || !jwt) {
                removeCookie('dashboardToken');
                localStorage?.removeItem('refresh');
                sessionStorage.clear();

                if (window && window.location) {
                  window.location.pathname = '/';
                }

                if (!isAlertDisplayed) {
                  alert(
                    '토큰 갱신에 실패하였습니다. 세션 만료로 자동 로그아웃 되었습니다.'
                  );
                  removeCookie('dashboardToken');
                  localStorage?.removeItem('refresh');
                  sessionStorage.clear();
                  isAlertDisplayed = true;
                }
              }
            }
          } else {
            removeCookie('dashboardToken');
            localStorage?.removeItem('refresh');
            sessionStorage.clear();

            if (window && window.location) {
              window.location.pathname = '/';
            }

            if (!isAlertDisplayed) {
              alert('세션 만료로 자동 로그아웃 되었습니다.');
              localStorage?.removeItem('refresh');
              removeCookie('dashboardToken');
              sessionStorage.clear();
              isAlertDisplayed = true;
            }
          }
        } else {
          removeCookie('dashboardToken');
          localStorage?.removeItem('refresh');
          sessionStorage.clear();

          if (window && window.location) {
            window.location.pathname = '/';
          }

          if (!isAlertDisplayed) {
            alert('세션 만료로 자동 로그아웃 되었습니다.');
            removeCookie('dashboardToken');
            localStorage?.removeItem('refresh');
            sessionStorage.clear();
            isAlertDisplayed = true;
          }
        }
      } else {
        console.log(res.status);
      }
      throw new Error(`Error! status: ${res.status}`);
    } else {
      return json;
    }
  } catch (error) {
    console.error(error);
  } finally {
    isAlertDisplayed = false;
  }
};

export const QueryKeys = {
  LOGIN: 'LOGIN',
  LOGOUT: 'LOGOUT',
  CENTERINFOR: 'CENTERINFOR',
  MONTHLYCHART: 'MONTHLYCHART',
  PERSONNELCHART: 'PERSONNELCHART',
  PERSONNELDETAIL: 'PERSONNELDETAIL',
  POSTURECHART: 'POSTURECHART',
  POSTUREDETAIL: 'POSTUREDETAIL',
  ROMCHART: 'ROMCHART',
  ROMDETAIL: 'ROMDETAIL'
};
